/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_X15_Provider_FailedInputs */

const en_auth_x15_provider_failed = /** @type {(inputs: Auth_X15_Provider_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google sign-in did not finish. Try again, or sign in with your email.`)
};

/** @type {(inputs: Auth_X15_Provider_FailedInputs) => LocalizedString} */
const ar_auth_x15_provider_failed = en_auth_x15_provider_failed;

/** @type {(inputs: Auth_X15_Provider_FailedInputs) => LocalizedString} */
const he_auth_x15_provider_failed = en_auth_x15_provider_failed;

/** @type {(inputs: Auth_X15_Provider_FailedInputs) => LocalizedString} */
const ur_auth_x15_provider_failed = en_auth_x15_provider_failed;

/** @type {(inputs: Auth_X15_Provider_FailedInputs) => LocalizedString} */
const es_auth_x15_provider_failed = en_auth_x15_provider_failed;

/** @type {(inputs: Auth_X15_Provider_FailedInputs) => LocalizedString} */
const fr_auth_x15_provider_failed = en_auth_x15_provider_failed;

/** @type {(inputs: Auth_X15_Provider_FailedInputs) => LocalizedString} */
const de_auth_x15_provider_failed = en_auth_x15_provider_failed;

/** @type {(inputs: Auth_X15_Provider_FailedInputs) => LocalizedString} */
const pt_auth_x15_provider_failed = en_auth_x15_provider_failed;

/** @type {(inputs: Auth_X15_Provider_FailedInputs) => LocalizedString} */
const hi_auth_x15_provider_failed = en_auth_x15_provider_failed;

/** @type {(inputs: Auth_X15_Provider_FailedInputs) => LocalizedString} */
const bn_auth_x15_provider_failed = en_auth_x15_provider_failed;

/**
* | output |
* | --- |
* | "Google sign-in did not finish. Try again, or sign in with your email." |
*
* @param {Auth_X15_Provider_FailedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const auth_x15_provider_failed = /** @type {((inputs?: Auth_X15_Provider_FailedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_X15_Provider_FailedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_auth_x15_provider_failed(inputs)
	if (locale === "he") return he_auth_x15_provider_failed(inputs)
	if (locale === "ur") return ur_auth_x15_provider_failed(inputs)
	if (locale === "es") return es_auth_x15_provider_failed(inputs)
	if (locale === "fr") return fr_auth_x15_provider_failed(inputs)
	if (locale === "de") return de_auth_x15_provider_failed(inputs)
	if (locale === "pt") return pt_auth_x15_provider_failed(inputs)
	if (locale === "hi") return hi_auth_x15_provider_failed(inputs)
	if (locale === "bn") return bn_auth_x15_provider_failed(inputs)
	return /** @type {LocalizedString} */ ("Google sign-in did not finish. Try again, or sign in with your email.")
});